import { z } from "zod";

/**
 * Appointment waitlist — patients waiting for a slot that isn't free yet.
 * Reception offers freed slots over WhatsApp (tap-to-send today; automatic
 * once Meta Cloud API keys land) and converts entries into real bookings.
 */

export const waitlistStatusSchema = z.enum(["waiting", "booked", "removed"]);
export type WaitlistStatus = z.infer<typeof waitlistStatusSchema>;

export const waitlistEntrySchema = z.object({
	id: z.string().uuid(),
	clinic_id: z.string().uuid(),
	patient_id: z.string().uuid(),
	doctor_id: z.string().uuid().nullable(),
	service_id: z.string().uuid().nullable(),
	preferred_from: z.string().nullable(),
	preferred_until: z.string().nullable(),
	notes: z.string().nullable(),
	status: waitlistStatusSchema,
	offered_at: z.string().datetime().nullable(),
	booked_appointment_id: z.string().uuid().nullable(),
	created_at: z.string().datetime(),
	// Joined display fields (reception worklist needs them in one call).
	patient_name: z.string(),
	patient_phone: z.string().nullable(),
	doctor_name: z.string().nullable(),
});
export type WaitlistEntryApi = z.infer<typeof waitlistEntrySchema>;

export const createWaitlistInputSchema = z.object({
	patient_id: z.string().uuid(),
	doctor_id: z.string().uuid().optional(),
	service_id: z.string().uuid().optional(),
	preferred_from: z.string().date().optional(),
	preferred_until: z.string().date().optional(),
	notes: z.string().max(500).optional(),
});
export type CreateWaitlistInput = z.infer<typeof createWaitlistInputSchema>;

export const updateWaitlistInputSchema = z.object({
	/** removed = taken off the list; booked = converted (pass the appointment). */
	status: z.enum(["booked", "removed"]),
	booked_appointment_id: z.string().uuid().optional(),
});
export type UpdateWaitlistInput = z.infer<typeof updateWaitlistInputSchema>;
